var _path, _g, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWagerwizlogomarch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 22,
    viewBox: "0 0 26 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_921_9042",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 26,
    height: 22
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.538818H25.163V21.508H0V0.538818Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_921_9042)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.1628 20.7156V20.791C25.1628 20.9813 25.0866 21.1638 24.9513 21.2983C24.8158 21.433 24.6322 21.5085 24.4407 21.5085H0.722072C0.530591 21.5085 0.346975 21.4329 0.211576 21.2983C0.0761783 21.1637 7.80123e-05 20.9813 0 20.791V20.7156C0.000289953 20.1166 0.203844 19.5352 0.577755 19.0653C0.951666 18.5956 1.47408 18.2649 2.06055 18.1267C3.00721 17.9038 3.93122 17.685 3.97007 17.6721H21.1942C21.2333 17.685 22.1572 17.9038 23.1036 18.1267C23.6899 18.2652 24.2119 18.5961 24.5856 19.0658C24.9592 19.5356 25.1625 20.1168 25.1628 20.7156Z",
    fill: "url(#paint0_linear_921_9042)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0418 17.8192H4.10153C4.07446 17.8192 4.04776 17.8128 4.02371 17.8004C3.99966 17.788 3.97897 17.77 3.96337 17.7481C3.94778 17.726 3.93775 17.7007 3.93413 17.6739C3.93051 17.6473 3.93342 17.6201 3.94258 17.5948L4.91692 14.8989H20.2147L21.2005 17.5942C21.2097 17.6195 21.2128 17.6467 21.2093 17.6735C21.2056 17.7002 21.1957 17.7257 21.1801 17.7477C21.1645 17.7698 21.1439 17.7879 21.1198 17.8003C21.0957 17.8128 21.0689 17.8192 21.0418 17.8192Z",
    fill: "url(#paint1_linear_921_9042)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1141 9.09151C21.1005 9.08543 21.0884 9.07656 21.0787 9.06547C21.069 9.05426 21.0619 9.04118 21.0579 9.02705C21.0538 9.01281 21.053 8.99798 21.0553 8.98338C21.0577 8.9689 21.0633 8.95501 21.0717 8.94287C21.328 8.56875 22.2093 7.09614 20.9807 6.06704C19.8621 5.13095 18.3402 5.64668 17.8078 6.77612C17.6051 7.21287 17.5852 7.71171 17.7527 8.163L20.2159 14.8984H4.91846L6.86125 9.51594C6.86125 9.51594 9.12784 3.12889 13.6098 1.33132C18.0917 -0.466256 22.9244 0.875269 24.1934 4.52425C25.4155 8.03841 22.1301 9.53673 21.1141 9.09151Z",
    fill: "#125CCE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3137 4.91828L22.4789 6.04802C21.2506 2.79367 16.816 2.62604 14.7034 6.73195C12.584 10.8501 14.5412 14.8993 14.5412 14.8993H4.91846L6.86125 9.51676C6.86125 9.51676 9.12784 3.12889 13.6098 1.33132C18.0917 -0.466256 22.9244 0.875269 24.1934 4.52425C24.2398 4.65822 24.28 4.78957 24.3137 4.91828Z",
    fill: "url(#paint2_linear_921_9042)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.06203 5.61898C9.30086 7.38099 10.0439 8.8433 11.8749 9.31666C12.8395 9.567 13.3297 9.69392 13.3455 9.69766C13.4713 9.73129 13.5461 9.82283 13.5704 9.97217C13.5765 10.0095 13.5683 10.0478 13.5477 10.0795C13.527 10.111 13.4952 10.1338 13.4587 10.1431C11.71 10.5955 10.1081 10.9036 9.43215 12.8813C9.24686 13.4229 9.06483 14.0784 8.88606 14.8479C8.87835 14.8805 8.86231 14.9105 8.83955 14.935C8.81678 14.9595 8.78809 14.9776 8.75632 14.9875C8.72454 14.9973 8.69078 14.9987 8.65841 14.9915C8.62605 14.9841 8.59619 14.9685 8.57182 14.946C8.51409 14.8937 8.47265 14.8152 8.44751 14.7106C8.09836 13.3058 7.8316 11.8743 6.5397 11.0227C5.85953 10.5744 4.66261 10.3476 3.89307 10.1543C3.85449 10.1446 3.81835 10.1267 3.78749 10.1019C3.75663 10.077 3.73189 10.0462 3.71522 10.0115C3.69856 9.97684 3.69045 9.93948 3.6915 9.90223C3.69255 9.8651 3.70274 9.82902 3.72127 9.79714C3.77248 9.7112 3.87863 9.64909 4.03971 9.61079C5.6696 9.2257 7.03411 9.01833 7.72825 7.43142C7.95263 6.91878 8.13048 6.40147 8.26177 5.87949L8.58439 4.82481C8.59293 4.79794 8.60985 4.77445 8.63263 4.75781C8.65541 4.74117 8.68286 4.73227 8.7109 4.73242C8.73893 4.73259 8.76608 4.74179 8.78833 4.75868C8.81056 4.77557 8.82671 4.79925 8.83438 4.82621L9.06203 5.61898Z",
    fill: "#FDFFFE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_921_9042",
    x1: -0.000294362,
    y1: 19.5902,
    x2: 25.1628,
    y2: 19.5902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74A9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0154D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_921_9042",
    x1: 3.93258,
    y1: 16.3588,
    x2: 21.2108,
    y2: 16.3588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0756D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#013FA0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_921_9042",
    x1: 13.2887,
    y1: 15.1635,
    x2: 16.7639,
    y2: 1.22481,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1465E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#1667E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#357DEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#488BF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#4F90F8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWagerwizlogomarch);
export default __webpack_public_path__ + "static/media/wagerwizlogomarch.9519e6cbcdb339913315504ee5a1e599.svg";
export { ForwardRef as ReactComponent };